import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../../config/config.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { handleProblem } from '../problems/problem.service';

@Injectable()
export class TaskSyncReserveWithGtNetService {
  constructor(private client: HttpClient, private configService: ConfigService) {}

  public syncReserveWithGtNet(taskId: string): Observable<any> {
    const url = `${this.configService.config.rest.apiV2Url}/tasks/${taskId}/sync-reserve-with-gtnet`;

    return this.client.post(url, {}).pipe(
      catchError(error => throwError(handleProblem(error)))
    );
  }
}
